export const sitePaths = [{
    path: "/",
    title: "Home"
  },
  {
    path: "/about",
    title: "About"
  },
  {
    path: "/resume",
    title: "Resume"
  },
  {
    path: "/projects",
    title: "Projects"
  },
  {
    path: "/design-system",
    title: "DS"
  }
]

export const socialLinks = [{
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/clifford-nelson-bba47459/",
    iconType: "&#xf30c;"
  },
  {
    title: "GitHub",
    link: "https://github.com/commander-clifford/",
    iconType: "&#xf300;"
  },
  {
    title: "Instagram",
    link: "https://www.instagram.com/highestcliff/",
    iconType: "&#xf16d;"
  }
]